import { render, staticRenderFns } from "./signIn-xp.vue?vue&type=template&id=51a7b4ae&"
import script from "./signIn-xp.vue?vue&type=script&lang=js&"
export * from "./signIn-xp.vue?vue&type=script&lang=js&"
import style0 from "./signIn-xp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports